export default __webpack_public_path__ + "static/media/tie.9889c907.svg";